import { forwardRef, type TextareaHTMLAttributes } from 'react';
import { cn } from '../../lib/cn';
import Field, { controlClass, type ControlSize } from './Field';

export interface TextAreaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  hint?: string;
  error?: string;
  size?: ControlSize;
}

const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>(function TextArea(
  { label, hint, error, required, size = 'lg', className, id, rows = 4, ...rest },
  ref,
) {
  return (
    <Field label={label} hint={hint} error={error} required={required} id={id}>
      {(ids) => (
        <textarea
          ref={ref}
          id={ids.id}
          aria-describedby={ids.describedBy}
          aria-invalid={ids.invalid || undefined}
          required={required}
          rows={rows}
          className={cn(
            controlClass(size, ids.invalid),
            // controlClass height is for one-line controls; a textarea grows.
            'h-auto min-h-22 py-2 resize-y',
            className,
          )}
          {...rest}
        />
      )}
    </Field>
  );
});

export default TextArea;
